import { useQuery } from "@tanstack/react-query";
import { getHomeSections } from "../../api/apiHomeSections";
import i18next from "i18next";

export const useGetHomeSections = (params) => {
    const {
        data,
        isLoading,
        error,
        refetch
    } = useQuery({
        queryKey: ['home-sections', params, i18next.language],
        queryFn: () => getHomeSections(params),
        retry: false,
    });

    const homeSections = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 10, total: 0 };

    return { homeSections, meta, isLoading, error, refetch };
};
